/**
 * 모드 전환 스플래시 — 개인↔학원 전환 시 잠깐 보여주는 1등급 풀스크린
 */
import React from 'react';
import styled, { keyframes } from 'styled-components';

const ModeSwitchSplash = ({ to }) => (
  <Overlay>
    <Mark>1등급</Mark>
    <Msg>{to === 'academy' ? '학원 모드로 전환 중이에요' : '개인 모드로 전환 중이에요'}</Msg>
  </Overlay>
);

export default ModeSwitchSplash;

const fade = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const pop = keyframes`
  0% { transform: scale(0.82); opacity: 0; }
  60% { transform: scale(1.06); }
  100% { transform: scale(1); opacity: 1; }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: ${({ theme }) => theme.colors.primaryGradient};
  animation: ${fade} 0.2s ease;
`;

const Mark = styled.p`
  font-size: 44px;
  font-weight: 800;
  letter-spacing: -1px;
  color: #fff;
  animation: ${pop} 0.5s ease;
`;

const Msg = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  animation: ${fade} 0.7s ease;
`;
